import { Component, Input, OnInit } from '@angular/core';
import { ShippingMode } from '../../models/shipping-mode';
import { ShippingService } from '../services/shipping.service';
import { ShippingModeRest } from '../../models/shipping-mode-rest';
import { Cart } from '../../models/cart';
import { TranslateService } from '@ngx-translate/core';
import { CartElement } from '../../models/cart-element';
import { CartService } from '../../shared/services/cart.service';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { MatCard } from '@angular/material/card';
import { CurrencyPipe } from '@angular/common';
import { TransformHtmlPipe } from '../../shared/pipe/transform-html.pipe';

@Component({
    selector: 'tw-shipping-mode',
    templateUrl: './shipping-mode.component.html',
    styleUrls: ['./shipping-mode.component.css'],
    imports: [MatRadioGroup, FormsModule, MatRadioButton, MatCard, CurrencyPipe, TransformHtmlPipe]
})
export class ShippingModeComponent implements OnInit {
    selectedShipping: ShippingModeRest;
    listShipping: ShippingModeRest[];
    @Input() shippingMode: ShippingMode;

    @Input() set data(val: any) {
        //  console.log(val);
        //if (this.shippingService.getHasMandatoryAddress()) {
            const cart = this.cartService.cartSub.value;
            if (val && val.territory) {
                this.listShipping = this.shippingService.getShippingByTerritory(val.territory, val.shippingMode.shippingModeRests, cart);
                this.setSelectedShipping();
            }
        //}

    }

    constructor(private shippingService: ShippingService, public translate: TranslateService, public cartService: CartService) {
    }

    ngOnInit() {
        //this.shippingService.isNeedPostalCode(ShippingMode);
        if (!this.listShipping) {
            this.listShipping = this.shippingMode.shippingModeRests;
        }

        this.setSelectedShipping();
    }

    getSelectedShipping($event) {
        this.shippingService.addShippingSelectedLocale(this.selectedShipping, this.shippingMode.event.key);
    }


    setSelectedShipping() {
        if (this.listShipping && this.listShipping.length === 1) {
            this.selectedShipping = this.listShipping[0];
            this.shippingService.addShippingSelectedLocale(this.selectedShipping, this.shippingMode.event.key);
        }
    }

}
